export const BASIC_FEATURES = [
    { checked: true, text: 'Sin anuncios' },
    { checked: true, text: 'Música ilimitada' },
    { checked: true, text: '2 escenas artísticas' },
    { checked: true, text: '3 sonidos ambientales' },
    { checked: false, text: 'Soporte prioritario' },
    { checked: false, text: 'Guarda tus plantillas favoritas' },
    { checked: false, text: 'Descarga fondos de pantalla' },
    { checked: false, text: 'Lista de tareas' },
    { checked: false, text: 'Bloc de notas' },
    { checked: false, text: 'Estadísticas' },
    { checked: false, text: 'Apoya a organizaciones de salud mental*' },
];
export const PREMIUM_FEATURES = [
    { checked: true, text: 'Sin anuncios' },
    { checked: true, text: 'Música ilimitada' },
    { checked: true, accent: '20', text: 'escenas y creciendo' },
    { checked: true, accent: '15+', text: 'sonidos para mezclar a tu gusto' },
    { checked: true, text: 'Soporte prioritario' },
    { checked: true, text: 'Guarda tus plantillas favoritas' },
    { checked: true, text: 'Descarga fondos de pantalla' },
    { checked: true, text: 'Lista de tareas' },
    { checked: true, text: 'Bloc de notas' },
    { checked: true, text: 'Estadísticas' },
    { checked: true, text: 'Apoya a organizaciones de salud mental*' },
];
